export default {
  markerArray: [
    {
      id_stand: 666,
      number: "Panggung",
      nama_stand: "Acara",
      active: false,
      polygon: [
        [-98.25, 362.1875],
        [-97.75, 362.4375],
        [-97.1875, 363],
        [-96.6875, 364],
        [-96.375, 365.75],
        [-96.4375, 378.875],
        [-96.625, 380.25],
        [-96.9375, 381.0625],
        [-97.3125, 381.625],
        [-97.875, 382.125],
        [-98.875, 382.3125],
        [-124.6875, 382.25],
        [-125.6875, 382.0625],
        [-126.3125, 381.4375],
        [-126.8125, 380.625],
        [-127.125, 379.75],
        [-127.25, 378.875],
        [-127.1875, 365.6875],
        [-127, 364.25],
        [-126.75, 363.375],
        [-126.5, 362.875],
        [-126.0625, 362.375],
        [-125.5, 362.0625],
        [-124.8125, 362],
      ],
    },
    {
      id_stand: 1,
      number: "Stand No. 1",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-208.625, 166.9375],
        [-208.625, 175.5625],
        [-217.3125, 175.5625],
        [-217.3125, 166.9375],
      ],
    },
    {
      id_stand: 2,
      number: "Stand No. 2",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-208.625, 175.5625],
        [-208.625, 184.3125],
        [-217.3125, 184.3125],
        [-217.3125, 175.5625],
      ],
    },
    {
      id_stand: 3,
      number: "Stand No. 3",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-208.625, 184.3125],
        [-208.625, 192.9375],
        [-217.3125, 192.9375],
        [-217.3125, 184.3125],
      ],
    },
    {
      id_stand: 4,
      number: "Stand No. 4",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-208.625, 192.9375],
        [-208.625, 201.625],
        [-217.3125, 201.625],
        [-217.3125, 192.9375],
      ],
    },
    {
      id_stand: 5,
      number: "Stand No. 5",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-208.625, 201.625],
        [-208.625, 210.3125],
        [-217.3125, 210.3125],
        [-217.3125, 201.625],
      ],
    },
    {
      id_stand: 6,
      number: "Stand No. 6",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-208.625, 210.3125],
        [-208.625, 219.0625],
        [-217.3125, 219.0625],
        [-217.3125, 210.3125],
      ],
    },
    {
      id_stand: 7,
      number: "Stand No. 7",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-225.8125, 210.3125],
        [-225.8125, 219.0625],
        [-234.6875, 219.0625],
        [-234.6875, 210.3125],
      ],
    },
    {
      id_stand: 8,
      number: "Stand No. 8",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-225.8125, 201.625],
        [-225.8125, 210.3125],
        [-234.6875, 210.3125],
        [-234.6875, 201.625],
      ],
    },
    {
      id_stand: 9,
      number: "Stand No. 9",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-225.8125, 192.9375],
        [-225.8125, 201.625],
        [-234.6875, 201.625],
        [-234.6875, 192.9375],
      ],
    },
    {
      id_stand: 10,
      number: "Stand No. 10",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-225.8125, 184.3125],
        [-225.8125, 192.9375],
        [-234.6875, 192.9375],
        [-234.6875, 184.3125],
      ],
    },
    {
      id_stand: 11,
      number: "Stand No. 11",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-225.8125, 175.5625],
        [-225.8125, 184.3125],
        [-234.6875, 184.3125],
        [-234.6875, 175.5625],
      ],
    },
    {
      id_stand: 12,
      number: "Stand No. 12",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-225.8125, 166.9375],
        [-225.8125, 175.5625],
        [-234.6875, 175.5625],
        [-234.6875, 166.9375],
      ],
    },
    {
      id_stand: 13,
      number: "Stand No. 13",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-234.6875, 166.9375],
        [-234.6875, 175.5625],
        [-243.25, 175.5625],
        [-243.25, 166.9375],
      ],
    },
    {
      id_stand: 14,
      number: "Stand No. 14",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-234.6875, 175.5625],
        [-234.6875, 184.3125],
        [-243.25, 184.3125],
        [-243.25, 175.5625],
      ],
    },
    {
      id_stand: 15,
      number: "Stand No. 15",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-234.6875, 184.3125],
        [-234.6875, 192.9375],
        [-243.25, 192.9375],
        [-243.25, 184.3125],
      ],
    },
    {
      id_stand: 16,
      number: "Stand No. 16",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-234.6875, 192.9375],
        [-234.6875, 201.625],
        [-243.25, 201.625],
        [-243.25, 192.9375],
      ],
    },
    {
      id_stand: 17,
      number: "Stand No. 17",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-234.6875, 201.625],
        [-234.6875, 210.3125],
        [-243.25, 210.3125],
        [-243.25, 201.625],
      ],
    },
    {
      id_stand: 18,
      number: "Stand No. 18",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-234.6875, 210.3125],
        [-234.6875, 219.0625],
        [-243.25, 219.0625],
        [-243.25, 210.3125],
      ],
    },
    {
      id_stand: 19,
      number: "Stand No. 19",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-229.75, 231.25],
        [-227.5625, 239.6875],
        [-235.8125, 241.9375],
        [-238.125, 233.625],
      ],
    },
    {
      id_stand: 20,
      number: "Stand No. 20",
      nama_stand: "Dekranasda",
      active: false,
      polygon: [
        [-227.5625, 239.6875],
        [-225.3125, 248],
        [-233.5625, 250.3125],
        [-235.8125, 241.9375],
      ],
    },
    {
      id_stand: 21,
      number: "Stand No. 21",
      nama_stand: "Pertamina",
      active: false,
      polygon: [
        [-217.0625, 255.125],
        [-217.0625, 263.5625],
        [-225.375, 263.5625],
        [-225.375, 255.125],
      ],
    },
    {
      id_stand: 22,
      number: "Stand No. 22",
      nama_stand: "Pertamina",
      active: false,
      polygon: [
        [-217.0625, 263.5625],
        [-217.0625, 271.875],
        [-225.375, 271.875],
        [-225.375, 263.5625],
      ],
    },
    {
      id_stand: 23,
      number: "Stand No. 23",
      nama_stand: "Pertamina",
      active: false,
      polygon: [
        [-217.0625, 271.875],
        [-217.0625, 280.25],
        [-225.375, 280.25],
        [-225.375, 271.875],
      ],
    },
    {
      id_stand: 24,
      number: "Stand No. 21",
      nama_stand: "Pertamina",
      active: false,
      polygon: [
        [-208.625, 263.5625],
        [-208.625, 255.125],
        [-217.0625, 255.125],
        [-217.0625, 263.5625],
      ],
    },
    {
      id_stand: 25,
      number: "Stand No. 22",
      nama_stand: "Pertamina",
      active: false,
      polygon: [
        [-208.625, 263.5625],
        [-208.625, 271.875],
        [-217.0625, 271.875],
        [-217.0625, 263.5625],
      ],
    },
    {
      id_stand: 26,
      number: "Stand No. 23",
      nama_stand: "Pertamina",
      active: false,
      polygon: [
        [-208.625, 271.875],
        [-208.625, 280.25],
        [-217.0625, 280.25],
        [-217.0625, 271.875],
      ],
    },
    {
      id_stand: 27,
      number: "Stand No. 27",
      nama_stand: "DISKOPERINDAG Kab Gresik",
      active: false,
      polygon: [
        [-207.625, 288.8125],
        [-203.125, 299.4375],
        [-210.875, 302.75],
        [-215.4375, 292.1875],
      ],
    },
    {
      id_stand: 28,
      number: "Stand No. 28",
      nama_stand: "DISKOPERINDAG Kab Gresik",
      active: false,
      polygon: [
        [-215.4375, 292.1875],
        [-210.875, 302.75],
        [-218.875, 306.0625],
        [-223.375, 295.625],
      ],
    },
    {
      id_stand: 29,
      number: "Stand No. 29",
      nama_stand: "Kab. Malang",
      active: false,
      polygon: [
        [-200.25, 316.375],
        [-194.3125, 321.1875],
        [-198.6875, 326.6875],
        [-204.5625, 321.9375],
      ],
    },
    {
      id_stand: 30,
      number: "Stand No. 30",
      nama_stand: "DEKRANASDA Kota Probolinggo",
      active: false,
      polygon: [
        [-194.3125, 321.1875],
        [-184.75, 328.875],
        [-189.1875, 334.375],
        [-198.6875, 326.6875],
      ],
    },
    {
      id_stand: 31,
      number: "Stand No. 31",
      nama_stand: "DISDAG Kota Surabaya",
      active: false,
      polygon: [
        [-184.75, 328.875],
        [-175.875, 335.9375],
        [-180.375, 341.5],
        [-189.1875, 334.375],
      ],
    },
    {
      id_stand: 32,
      number: "Stand No. 32",
      nama_stand: "DISDAG Kota Kediri",
      active: false,
      polygon: [
        [-175.875, 335.9375],
        [-167.0625, 343.125],
        [-171.6875, 348.75],
        [-180.375, 341.5],
      ],
    },
    {
      id_stand: 33,
      number: "Stand No. 33",
      nama_stand: "DISPERINDAG Kab. Kediri",
      active: false,
      polygon: [
        [-167.0625, 343.125],
        [-158.25, 350.3125],
        [-162.75, 355.9375],
        [-171.6875, 348.75],
      ],
    },
    {
      id_stand: 34,
      number: "Stand No. 34",
      nama_stand: "DINKOP Kota Malang",
      active: false,
      polygon: [
        [-158.25, 350.3125],
        [-149.375, 357.5],
        [-154.0625, 363.125],
        [-162.75, 355.9375],
      ],
    },
    {
      id_stand: 35,
      number: "Stand No. 35",
      nama_stand: "DINKOP Kota Malang",
      active: false,
      polygon: [
        [-149.375, 357.5],
        [-140.3125, 364.6875],
        [-144.9375, 370.5625],
        [-154.0625, 363.125],
      ],
    },
    {
      id_stand: 36,
      number: "Stand No. 36 dan 37",
      nama_stand: "DISPERINDAG Kab. Pasuruan",
      active: false,
      polygon: [
        [-195.4375, 310.3125],
        [-180, 322.9375],
        [-184.75, 328.875],
        [-200.25, 316.375],
      ],
    },
    {
      id_stand: 38,
      number: "Stand No. 38",
      nama_stand: "DISKOPERINDAG Kab. Bondowoso",
      active: false,
      polygon: [
        [-180, 322.9375],
        [-171.1875, 330.125],
        [-175.875, 335.9375],
        [-184.75, 328.875],
      ],
    },
    {
      id_stand: 39,
      number: "Stand No. 39",
      nama_stand: "Kab. Jember",
      active: false,
      polygon: [
        [-171.1875, 330.125],
        [-162.3125, 337.3125],
        [-167.0625, 343.125],
        [-175.875, 335.9375],
      ],
    },
    {
      id_stand: 40,
      number: "Stand No. 40",
      nama_stand: "Sumenep",
      active: false,
      polygon: [
        [-162.3125, 337.3125],
        [-153.5, 344.5],
        [-158.25, 350.3125],
        [-167.0625, 343.125],
      ],
    },
    {
      id_stand: 41,
      number: "Stand No. 41",
      nama_stand: "Sumenep",
      active: false,
      polygon: [
        [-153.5, 344.5],
        [-144.5625, 351.75],
        [-149.375, 357.5],
        [-158.25, 350.3125],
      ],
    },
    {
      id_stand: 42,
      number: "Stand No. 42",
      nama_stand: "DEKRANASDA Kota Madiun",
      active: false,
      polygon: [
        [-144.5625, 351.75],
        [-135.8125, 358.9375],
        [-140.3125, 364.6875],
        [-149.375, 357.5],
      ],
    },
    {
      id_stand: 43,
      number: "Stand No. 43",
      nama_stand: "PERABA",
      active: false,
      polygon: [
        [-124.875, 310.9375],
        [-124.875, 319.9375],
        [-133.5, 319.9375],
        [-133.5, 310.9375],
      ],
    },
    {
      id_stand: 44,
      number: "Stand No. 44",
      nama_stand: "PERSANA",
      active: false,
      polygon: [
        [-124.875, 301.9375],
        [-124.875, 310.9375],
        [-133.5, 310.9375],
        [-133.5, 301.9375],
      ],
    },
    {
      id_stand: 46,
      number: "Stand No. 46 & 48",
      nama_stand: "UPT Aneka Industri & Kerajinan",
      active: false,
      polygon: [
        [-105, 281.4375],
        [-105, 292.125],
        [-116.375, 292.125],
        [-116.375, 281.4375],
      ],
    },
    {
      id_stand: 47,
      number: "Stand No. 47",
      nama_stand: "RANDHYSA",
      active: false,
      polygon: [
        [-110.625, 269.5625],
        [-110.625, 281.4375],
        [-116.375, 281.4375],
        [-116.375, 269.5625],
      ],
    },
    {
      id_stand: 49,
      number: "Stand No. 49",
      nama_stand: "Namira Eco Print",
      active: false,
      polygon: [
        [-105, 269.5625],
        [-105, 281.4375],
        [-110.625, 281.4375],
        [-110.625, 269.5625],
      ],
    },
    {
      id_stand: 51,
      number: "Stand No. 51",
      nama_stand: "APBJ",
      active: false,
      polygon: [
        [-124.75, 266.4375],
        [-124.75, 277.1875],
        [-142.9375, 277.1875],
        [-142.9375, 266.4375],
      ],
    },
    {
      id_stand: 52,
      number: "Stand No. 52",
      nama_stand: "PERSADIR",
      active: false,
      polygon: [
        [-134.0625, 255.4375],
        [-129.6875, 261.875],
        [-129.6875, 266.4375],
        [-142.9375, 266.4375],
        [-142.9375, 255.4375],
      ],
    },
    {
      id_stand: 53,
      number: "Stand No. 53",
      nama_stand: "RASYid_standIN",
      active: false,
      polygon: [
        [-193.375, 210.5625],
        [-193.375, 219.1875],
        [-202, 219.1875],
        [-202, 210.5625],
      ],
    },
    {
      id_stand: 54,
      number: "Stand No. 54",
      nama_stand: "Perada Batik",
      active: false,
      polygon: [
        [-184.625, 219.1875],
        [-184.625, 210.5625],
        [-193.375, 210.5625],
        [-193.375, 219.1875],
      ],
    },
    {
      id_stand: 55,
      number: "Stand No. 55",
      nama_stand: "Elfisha",
      active: false,
      polygon: [
        [-176, 210.5625],
        [-176, 219.1875],
        [-184.625, 219.1875],
        [-184.625, 210.5625],
      ],
    },
    {
      id_stand: 56,
      number: "Stand No. 56 & 57",
      nama_stand: "OZZY Batik",
      active: false,
      polygon: [
        [-158.6875, 219.1875],
        [-158.6875, 210.5625],
        [-176, 210.5625],
        [-176, 219.1875],
      ],
    },
    {
      id_stand: 58,
      number: "Stand No. 58",
      nama_stand: "Dewi Collection",
      active: false,
      polygon: [
        [-149.4375, 210.5625],
        [-149.4375, 219.1875],
        [-158.6875, 219.1875],
        [-158.6875, 210.5625],
      ],
    },
    {
      id_stand: 59,
      number: "Stand No. 59",
      nama_stand: "Batikeun Mamauty",
      active: false,
      polygon: [
        [-141.0625, 219.1875],
        [-141.0625, 210.5625],
        [-149.4375, 210.5625],
        [-149.4375, 219.1875],
      ],
    },
    {
      id_stand: 60,
      number: "Stand No. 60",
      nama_stand: "Brotoseno",
      active: false,
      polygon: [
        [-110.8125, 182.4375],
        [-110.8125, 193.8125],
        [-116.75, 193.8125],
        [-116.75, 182.4375],
      ],
    },
    {
      id_stand: 61,
      number: "Stand No. 61",
      nama_stand: "Etnura",
      active: false,
      polygon: [
        [-110.8125, 170.9375],
        [-110.8125, 182.4375],
        [-116.75, 182.4375],
        [-116.75, 170.9375],
      ],
    },
    {
      id_stand: 62,
      number: "Stand No. 62",
      nama_stand: "Bank BPR",
      active: false,
      polygon: [
        [-110.8125, 159.5625],
        [-110.8125, 170.9375],
        [-116.75, 170.9375],
        [-116.75, 159.5625],
      ],
    },
    {
      id_stand: 63,
      number: "Stand No. 63",
      nama_stand: "Dewi Collection",
      active: false,
      polygon: [
        [-104.5625, 193.8125],
        [-104.5625, 182.4375],
        [-110.8125, 182.4375],
        [-110.8125, 193.8125],
      ],
    },
    {
      id_stand: 64,
      number: "Stand No. 64",
      nama_stand: "untitled",
      active: false,
      polygon: [
        [-104.5625, 182.4375],
        [-104.5625, 170.9375],
        [-110.8125, 170.9375],
        [-110.8125, 182.4375],
      ],
    },
    {
      id_stand: 65,
      number: "Stand No. 65",
      nama_stand: "Safe Care",
      active: false,
      polygon: [
        [-104.5625, 170.9375],
        [-104.5625, 159.5625],
        [-110.8125, 159.5625],
        [-110.8125, 170.9375],
      ],
    },
    {
      id_stand: 66,
      number: "Stand No. 66",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-105, 138.625],
        [-105, 150.0625],
        [-110.6875, 150.0625],
        [-110.6875, 138.625],
      ],
    },
    {
      id_stand: 67,
      number: "Stand No. 67",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-105, 127.1875],
        [-105, 138.625],
        [-110.6875, 138.625],
        [-110.6875, 127.1875],
      ],
    },
    {
      id_stand: 68,
      number: "Stand No. 68",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-105, 115.75],
        [-105, 127.1875],
        [-110.6875, 127.1875],
        [-110.6875, 115.75],
      ],
    },
    {
      id_stand: 69,
      number: "Stand No. 69",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-105, 104.3125],
        [-105, 115.75],
        [-110.6875, 115.75],
        [-110.6875, 104.3125],
      ],
    },
    {
      id_stand: 70,
      number: "Stand No. 70",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-110.6875, 150.0625],
        [-110.6875, 138.625],
        [-116.375, 138.625],
        [-116.375, 150.0625],
      ],
    },
    {
      id_stand: 71,
      number: "Stand No. 71",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-110.6875, 138.625],
        [-110.6875, 127.1875],
        [-116.375, 127.1875],
        [-116.375, 138.625],
      ],
    },
    {
      id_stand: 72,
      number: "Stand No. 72",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-110.6875, 127.1875],
        [-110.6875, 115.75],
        [-116.375, 115.75],
        [-116.375, 127.1875],
      ],
    },
    {
      id_stand: 73,
      number: "Stand No. 73",
      nama_stand: "Asosiasi",
      active: false,
      polygon: [
        [-110.6875, 115.75],
        [-110.6875, 104.3125],
        [-116.375, 104.3125],
        [-116.375, 115.75],
      ],
    },
    {
      id_stand: 74,
      number: "Stand No. 74",
      nama_stand: "YH Batik Klaten",
      active: false,
      polygon: [
        [-153.4375, 86.75],
        [-162.3125, 93.8125],
        [-165.9375, 89.4375],
        [-157.0625, 82.25],
      ],
    },
    {
      id_stand: 75,
      number: "Stand No. 75 & 76",
      nama_stand: "Deallova Shoes & Urane Tshirt",
      active: false,
      polygon: [
        [-162.3125, 93.8125],
        [-180.125, 108.25],
        [-183.75, 103.875],
        [-165.9375, 89.4375],
      ],
    },
    {
      id_stand: 77,
      number: "Stand No. 77",
      nama_stand: "Babeh Exclusive Tailor",
      active: false,
      polygon: [
        [-180.125, 108.25],
        [-189, 115.5625],
        [-192.5625, 111.125],
        [-183.75, 103.875],
      ],
    },
    {
      id_stand: 78,
      number: "Stand No. 78",
      nama_stand: "De' Youl",
      active: false,
      polygon: [
        [-157.0625, 82.25],
        [-165.9375, 89.4375],
        [-169.5, 85.0625],
        [-160.6875, 77.875],
      ],
    },
    {
      id_stand: 79,
      number: "Stand No. 79",
      nama_stand: "JF Bags",
      active: false,
      polygon: [
        [-165.9375, 89.4375],
        [-175, 96.6875],
        [-178.8125, 92.5625],
        [-169.5, 85.0625],
      ],
    },
    {
      id_stand: 80,
      number: "Stand No. 80",
      nama_stand: "Dudung Batik Pekalongan",
      active: false,
      polygon: [
        [-175, 96.6875],
        [-183.75, 103.875],
        [-187.3125, 99.4375],
        [-178.8125, 92.5625],
      ],
    },
    {
      id_stand: 81,
      number: "Stand No. 81",
      nama_stand: "Umbul Tirta",
      active: false,
      polygon: [
        [-183.75, 103.875],
        [-192.5625, 111.125],
        [-196.1875, 106.5625],
        [-187.3125, 99.4375],
      ],
    },
    {
      id_stand: 82,
      number: "Stand No. 82",
      nama_stand: "X",
      active: false,
      polygon: [
        [-196.1875, 115.0625],
        [-201.5625, 121.5625],
        [-208.3125, 116.0625],
        [-203.0625, 109.4375],
      ],
    },
    {
      id_stand: 83,
      number: "Stand No. 83",
      nama_stand: "X",
      active: false,
      polygon: [
        [-201.5625, 121.5625],
        [-207.5, 128.9375],
        [-214.4375, 123.4375],
        [-208.3125, 116.0625],
      ],
    },
    {
      id_stand: 84,
      number: "Stand No. 84",
      nama_stand: "DISKOP UKM Provinsi JATIM",
      active: false,
      polygon: [
        [-207.5, 128.9375],
        [-212.9375, 135.625],
        [-219.75, 130.1875],
        [-214.4375, 123.4375],
      ],
    },
    {
      id_stand: 85,
      number: "Stand No. 85",
      nama_stand: "DISKOP UKM Provinsi JATIM",
      active: false,
      polygon: [
        [-212.9375, 135.625],
        [-218.3125, 142.375],
        [-225.0625, 136.875],
        [-219.75, 130.1875],
      ],
    },
    {
      id_stand: 86,
      number: "Stand No. 86",
      nama_stand: "DISKOP UKM Provinsi JATIM",
      active: false,
      polygon: [
        [-218.3125, 142.375],
        [-223.625, 148.9375],
        [-230.4375, 143.4375],
        [-225.0625, 136.875],
      ],
    },
    {
      id_stand: 87,
      number: "Stand No. 87",
      nama_stand: "X",
      active: false,
      polygon: [
        [-189.5, 120.625],
        [-194.8125, 127.1875],
        [-201.5625, 121.5625],
        [-196.1875, 115.0625],
      ],
    },
    {
      id_stand: 88,
      number: "Stand No. 88",
      nama_stand: "X",
      active: false,
      polygon: [
        [-194.8125, 127.1875],
        [-200.625, 134.4375],
        [-207.5, 128.9375],
        [-201.5625, 121.5625],
      ],
    },
    {
      id_stand: 89,
      number: "Stand No. 89",
      nama_stand: "Mia Bordir",
      active: false,
      polygon: [
        [-200.625, 134.4375],
        [-206.0625, 141.125],
        [-212.9375, 135.625],
        [-207.5, 128.9375],
      ],
    },
    {
      id_stand: 90,
      number: "Stand No. 90",
      nama_stand: "Batik & Tenun Ratna Asih",
      active: false,
      polygon: [
        [-206.0625, 141.125],
        [-211.375, 147.8125],
        [-218.3125, 142.375],
        [-212.9375, 135.625],
      ],
    },
    {
      id_stand: 91,
      number: "Stand No. 91",
      nama_stand: "DISPERINDAG Kab. Blitar",
      active: false,
      polygon: [
        [-211.375, 147.8125],
        [-216.75, 154.4375],
        [-223.625, 148.9375],
        [-218.3125, 142.375],
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/component/marker.js